const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['gamilytics/forum/leaderboards/components/LeaderboardHero'];